export default __webpack_public_path__ + "static/team-member-07-370x455-4b2f439dbfeddd1f5b15977497fb8cb1.jpg";